import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <footer className='footer'>
      <div className='container'>
        <p className='text-muted'>Copyright © 2024 GitHub Repo Explorer. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer